import React from "react";
import axios from "axios";
import { withRouter } from "react-router-dom";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {
    username,
    getAuthorizationHeader,
    URL
} from "../../constans/constants";
import DropzoneComponent from "../componentes/DropzoneComponent";
import PantallaCarga from "../mensajeFlash/PantallaCarga";
import { obtenerDatosUsuario } from "../usuario/UsuarioService";
import MensajeFlash from "../mensajeFlash/MensajeFlash";
import { ReactComponent as CalendarIcon } from "../../assets/images/icons/calendar_16.svg";
import {
    mostrarErroresEnFormulario, configurarLimpiezaAutomatica,
    integrarConHandleInput, limpiarErrorCampo
} from '../../constans/form-error-utils';

const CustomDateInput = React.forwardRef(({ value, onClick, onChange, name, label }, ref) => (
    <div className="datepicker-wrapper">
        <div className="form-group-local">
            <input
                type="text"
                className="form-input"
                onClick={onClick}
                onChange={onChange}
                value={value}
                name={name}
                ref={ref}
                id={name}
                autoComplete="off"
                placeholder=""
            />
            <label htmlFor={name} className="form-label">
                {label}
            </label>
            <span className="icon-calendar-local">
                <CalendarIcon width={16} height={16} />
            </span>
        </div>

    </div>
));

class ReposoMedico extends React.Component {

    constructor(props) {

        super(props);


        const originalHandleInput = this.handleInput;

        this.handleInput = integrarConHandleInput(this, originalHandleInput);

        this.state = {
            cedulaIdentidad: "",
            nombre: "",
            fechaDesde: "",
            fechaHasta: "",
            fechaDesdeCargada: false,
            fechahastaCargada: false,
            motivoReposo: "",
            certificadoMedico: null,
            pesoArchivoMb: null,
            validated: false,
            errorMessage: '',
            errors: {
                cedulaIdentidad: null,
                nombre: null,
                fechaDesde: null,
                fechaHasta: null,
                motivoReposo: null,
                certificadoMedico: null
            },
            mensajeFlash: "",
            mostrarMensajeFlash: false,
            mensajeFlashSeverity: "neutral",
        };
    }

    componentDidMount() {
        configurarLimpiezaAutomatica()
        this.fetchDatosUsuario(username());
    }

    fetchDatosUsuario = (username) => {
        obtenerDatosUsuario(username).then((resp) => {
            if (!resp.error)
                this.setState({
                    cedulaIdentidad: resp.datos.cedula,
                    nombre: resp.datos.nombres + " " + resp.datos.apellidos
                })
            else {
                this.setState((prevState) => ({
                    errors: {
                        ...prevState.errors,
                        cedulaIdentidad: "Error al recuperar datos",
                        nombre: "Error al recuperar datos",
                    },
                }));
            }
        })
    }

    handleSubmit = (event) => {
        event.preventDefault();
        const { isValid, errors } = this.validarFormulario();
        if (!isValid) {
            this.setState({ errors: errors, showErrors: true });
            mostrarErroresEnFormulario(errors);
        } else {
            mostrarErroresEnFormulario({});
            this.descargarRecibo();
        }
    };

    validarFormulario = () => {
        let isValid = true;
        let errors = {
            cedulaIdentidad: null,
            nombre: null,
            fechaDesde: null,
            fechaHasta: null,
            motivoReposo: null,
            certificadoMedico: null
        };
        let erroresFechas = this.validarFechas(
            this.state.fechaDesde,
            this.state.fechaHasta
        );
        errors.fechaDesde = erroresFechas.fechaDesde;
        errors.fechaHasta = erroresFechas.fechaHasta;
        if (erroresFechas.fechaDesde !== null || erroresFechas.fechaHasta !== null)
            isValid = false;

        if (this.state.motivoReposo.trim().length == 0) {
            isValid = false;
            errors.motivoReposo = "Debe especificar un motivo de reposo"
        }

        if (this.state.certificadoMedico == null) {
            isValid = false;
            errors.certificadoMedico = "Debe adjuntar el certificado médico"
        }

        return { isValid, errors };
    };

    validarFechas = (desde, hasta) => {
        const fechaActual = new Date();
        let fechaDesde = new Date(desde);
        let fechaHasta = new Date(hasta);
        let erroresFechas = {
            fechaDesde: null,
            fechaHasta: null,
        };

        if (isNaN(fechaDesde.getTime())) {
            erroresFechas.fechaDesde = "Fecha inicio no válida";
        }
        if (isNaN(fechaHasta.getTime())) {
            erroresFechas.fechaHasta = "Fecha fin no válida";
        }
        if (!fechaDesde.getDate() >= fechaActual.getDate()) {
            erroresFechas.fechaDesde = "Fecha inicio es menor a fecha actual";
        }
        if (fechaHasta.getTime() < fechaDesde.getTime()) {
            erroresFechas.fechaHasta = "Fecha fin es menor o igual a fecha inicio";
        }

        return erroresFechas;
    };

    formatFileSize = (bytes, decimals = 2) => {
        if (bytes === 0) return '0 Bytes';

        const k = 1024;
        const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

        const i = Math.floor(Math.log(bytes) / Math.log(k));

        return parseFloat((bytes / Math.pow(k, i)).toFixed(decimals)) + sizes[i];
    }

    handleArchivo = (archivo) => {
        this.setState({ certificadoMedico: archivo, nombreArchivo: archivo.name, pesoArchivoMb: this.formatFileSize(archivo.size) })
        limpiarErrorCampo("certificadoMedico")
    }


    fileToBase64(file) {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = () => resolve(reader.result.split(',')[1]); // Remueve el prefijo `data:*/*;base64,`
            reader.onerror = (error) => reject(error);
            reader.readAsDataURL(file);
        });
    }

    calcularDiasHabiles(fechaInicio, fechaFin, diasFeriados = []) {
        // Asegurarnos de que las fechas estén en el formato Date
        const inicio = new Date(fechaInicio);
        const fin = new Date(fechaFin);
        if (inicio > fin) {
            throw new Error("La fecha de inicio debe ser anterior a la fecha de fin");
        }

        // Convertir los días feriados a strings en formato 'YYYY-MM-DD'
        const diasFeriadosStr = diasFeriados.map(dia => new Date(dia).toISOString().split('T')[0]);

        let diasHabiles = 0;

        // Iterar sobre las fechas desde inicio hasta fin
        for (let fecha = new Date(inicio); fecha <= fin; fecha.setDate(fecha.getDate() + 1)) {
            const diaSemana = fecha.getDay(); // 0 = Domingo, 6 = Sábado
            const fechaStr = fecha.toISOString().split('T')[0]; // Convertir fecha actual a 'YYYY-MM-DD'

            // Contar como día hábil si no es fin de semana ni día feriado
            if (diaSemana !== 0 && diaSemana !== 6 && !diasFeriadosStr.includes(fechaStr)) {
                diasHabiles++;
            }
        }

        return diasHabiles;
    }

    descargarRecibo = async () => {
        this.setState({ openPantallaCarga: true });

        const url = URL + "tramite/pdf/tipoTramite/" + this.props.idFormulario;

        try {
            const certificadoMedicoBase64 = await this.fileToBase64(this.state.certificadoMedico);

            const bodyRequest = {
                cedulaIdentidad: this.state.cedulaIdentidad,
                nombre: this.state.nombre,
                fechaInicio: this.state.fechaDesde,
                fechaFin: this.state.fechaHasta,
                motivoReposo: this.state.motivoReposo,
                cantidadDias: this.calcularDiasHabiles(
                    this.state.fechaDesde,
                    this.state.fechaHasta
                ),
                certificadoMedico: certificadoMedicoBase64,
            };

            const response = await axios.post(url, bodyRequest, {
                ...getAuthorizationHeader(),
                responseType: "blob",
            });

            const file = new Blob([response.data], { type: "application/pdf" });
            const fileURL = window.URL.createObjectURL(file);
            this.setState({ openPantallaCarga: false });
            this.props.terminarCargaDatos(fileURL, bodyRequest);
        } catch (error) {
            this.setState({ openPantallaCarga: false });
            console.error("Error al descargar el recibo:", error);
        }
    };

    handleFechaDesdeChange = (date) => {
        this.setState((prevState) => ({
            errors: {
                ...prevState.errors,
                fechaDesde: null,
            },
            fechaDesde: date,
            fechaDesdeCargada: true
        }));
    }

    handleFechaHastaChange = (date) => {
        this.setState((prevState) => ({
            errors: {
                ...prevState.errors,
                fechaHasta: null,
            },
            fechaHasta: date,
            fechahastaCargada: true
        }));
    }

    handleBotonCancelar = () => {
        this.props.history.push('/tramites/generar')
    }

    handleInput = (e) => {
        const name = e.target.name;
        const val = e.target.value;
        this.setState((prevState) => ({
            errors: {
                ...prevState.errors,
                [name]: null,
            },
            [name]: val,
        }));
    };


    render() {
        return (
            <>
                <PantallaCarga open={this.state.openPantallaCarga} />
                <form onSubmit={this.handleSubmit}>
                    <h4 className="section__subtitle center-text">
                        Cargar certificado médico
                    </h4>
                    <p className="section__description center-text">
                        Selecciona el certificado médico a cargar en formato pdf o imagen
                    </p>

                    <div className="carga-documento-section" name="certificadoMedico">
                        <div className="carga-documento-content">
                            <DropzoneComponent
                                onFileSelected={this.handleArchivo}
                                archivos_soportados={["pdf", "jpeg", "png"]}
                            />
                        </div>
                    </div>

                    {this.state.certificadoMedico && (
                        <div className="component-progress-upload">
                            <div className="contentInner">
                                <div className="icon-shape shape-xl">
                                    <span className="material-symbols-outlined">folder_zip</span>
                                </div>
                                <div className="progress-content">
                                    <div className="load-info">
                                        <span className="file-name">{this.state.certificadoMedico.name}</span>
                                    </div>
                                    <div className="file-info">
                                        <span className="file-size">{this.state.pesoArchivoMb}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}

                    <div className="form-group__inline x2">

                        <div className="form-group">
                            <input type="text" name="cedulaIdentidad" disabled className="form-input" value={this.state.cedulaIdentidad} />
                            <label htmlFor="cedulaIdentidad" className="form-label"> Cedula de identidad </label>
                        </div>

                        <div className="form-group">
                            <input type="text" name="nombre" disabled className="form-input" value={this.state.nombre} />
                            <label htmlFor="nombre" className="form-label"> Solicitante </label>
                        </div>

                    </div>

                    <div className="form-group__inline x2">
                        <div className="form-group">
                            <DatePicker
                                showIcon
                                selectsStart
                                selected={this.state.fechaDesde}
                                onChange={this.handleFechaDesdeChange}
                                customInput={
                                    <CustomDateInput name="fechaDesde" label="Fecha desde" />
                                }
                                startDate={this.state.fechaDesde}
                                dateFormat="dd/MM/yyyy"
                                minDate={new Date()}
                                required
                            />
                        </div>

                        <div className="form-group">
                            <DatePicker
                                showIcon
                                selectsEnd
                                selected={this.state.fechaHasta}
                                name="fechaHasta"
                                customInput={
                                    <CustomDateInput name="fechaHasta" label="Fecha hasta" />
                                }
                                onChange={this.handleFechaHastaChange}
                                dateFormat="dd/MM/yyyy"
                                endDate={this.state.fechaHasta}
                                startDate={this.state.fechaDesde}
                                minDate={this.state.fechaDesde}
                                required
                            />
                        </div>
                    </div>

                    <div className="form-group">
                        <textarea type="text" id="motivoReposo" name="motivoReposo" rows="12" className="form-input" placeholder="" value={this.state.motivoReposo} onChange={this.handleInput} />
                        <label htmlFor="motivoReposo" className="form-label"> Motivo del reposo </label>
                    </div>

                    <div className="form-actions">
                        <button onClick={() => this.handleBotonCancelar()} className="btn-medium btn-link"> Cancelar </button>
                        <button type="submit" className="btn-medium btn-primary"> Continuar </button>
                    </div>
                </form >
                <MensajeFlash
                    visible={this.state.mostrarMensajeFlash}
                    mensaje={this.state.mensajeFlash}
                    severity={this.state.mensajeFlashSeverity} />
            </>
        )
    }
}

export default withRouter(ReposoMedico)